﻿import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../../resources/ResourcesStore";
import type { IUploadStore } from "../../../UploadStore";
import { injectFromAppUpload } from "../../../inject";
import { NotUploadableFilesComponent } from "../not-uploadable/NotUploadableFilesComponent";
import { DobButton } from "@dedalusdiit/dob-components";

interface ISelectedFilesComponentProps {
    resourcesStore?: IResourcesStore;
    uploadStore?: IUploadStore;
}

@injectFromAppUpload<ISelectedFilesComponentProps>(stores => ({
    uploadStore: stores.uploadStore,
    resourcesStore: stores.resourcesStore,
}))
@observer
export class SelectedFilesComponent extends React.Component<ISelectedFilesComponentProps> {
    resetFiles = (event): void => {
        const { uploadStore } = this.props;
        uploadStore!.resetFiles();
    };

    render() {
        const { resourcesStore, uploadStore } = this.props;
        const { numberOfSelectedFiles, inputChanged } = uploadStore!;

        if (numberOfSelectedFiles <= 0 && !inputChanged) {
            return null;
        }

        const { numberOfCheckingFiles, somethingIsUploading, filesNotUploadable, numberOfDICOMFiles, numberOfNonDICOMFiles } = uploadStore!;
        const { resources } = resourcesStore!;

        return (
            <div id={"selected-files-component"}>
                <div>
                    <div id={"checking-selected"} className={"selected-files" + (numberOfCheckingFiles > 0 || inputChanged ? " checking" : "")}>
                        {inputChanged && numberOfCheckingFiles <= 0 ? (
                            <span>{resources.LoadingRecords}</span>
                        ) : (
                            <span>
                                {numberOfCheckingFiles > 0
                                    ? resources.CheckingXOfTheXSelectedFiles.replace("{0}", numberOfCheckingFiles.toString()).replace("{1}", numberOfSelectedFiles.toString())
                                    : resources.XSelectedFiles.replace("{0}", numberOfSelectedFiles.toString())}
                            </span>
                        )}
                        <DobButton
                            color={"neutral"}
                            outline={true}
                            onClick={this.resetFiles}
                            disabled={numberOfCheckingFiles > 0 || numberOfSelectedFiles === 0 || somethingIsUploading}
                        >
                            {resources.Reset}
                        </DobButton>
                    </div>
                    <div id={"uploadable"} className={"selected-files"}>
                        {resources.XDICOMFiles.replace("{0}", numberOfDICOMFiles.toString())}
                    </div>
                    <div id={"uploadable"} className={"selected-files"}>
                        {resources.XOtherFiles.replace("{0}", numberOfNonDICOMFiles.toString())}
                    </div>
                    <div id={"not-uploadable"} className={"selected-files"}>
                        {resources.XUnsupportedFiles.replace("{0}", filesNotUploadable.length.toString())}
                    </div>
                </div>
                <NotUploadableFilesComponent />
            </div>
        );
    }
}
